import { render, staticRenderFns } from "./RepeatFreqSelect.vue?vue&type=template&id=0ebab6ae"
import script from "./RepeatFreqSelect.vue?vue&type=script&lang=js"
export * from "./RepeatFreqSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports